module.exports = __webpack_public_path__ + "img/health25_7-9-2021.ea17ca4b.jpg";